import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import { FaRobot } from 'react-icons/fa';
import { useAiAssistant } from '../context/AiAssistantContext';
import './BookingAssistantFAB.css';

const HIDDEN_PATHS = ['/ai-assistant', '/login', '/workspace/login'];

const BookingAssistantFAB = () => {
  const location = useLocation();
  const { widgetOpen, toggleWidget } = useAiAssistant();

  if (HIDDEN_PATHS.some((p) => location.pathname.startsWith(p))) {
    return null;
  }

  return createPortal(
    <button
      type="button"
      className={`ai-assistant-fab${widgetOpen ? ' ai-assistant-fab--open' : ''}`}
      onClick={toggleWidget}
      aria-label={widgetOpen ? 'Close AI booking assistant' : 'Open AI booking assistant'}
      aria-expanded={widgetOpen}
    >
      <FaRobot />
      <span>{widgetOpen ? 'Close AI' : 'AI Stay Finder'}</span>
    </button>,
    document.body
  );
};

export default BookingAssistantFAB;
